import React from 'react';
import { ArrowLeft, ExternalLink, Mail, Moon, Sun } from 'lucide-react';

const founders = [
  {
    name: 'Snehal Pal',
    institution: 'IIT Kharagpur',
    image: '/founders/snehal-pal.jpg',
    email: 'palsnehal004@gmail.com',
    website: 'https://snehalpal.vercel.app/',
  },
  {
    name: 'Subhradeep Dey',
    institution: 'NIT Trichy',
    image: '/founders/subhradeep-dey.jpg',
  },
];

export default function FoundersPage({ darkMode, setDarkMode }) {
  return (
    <main className={`min-h-screen transition-colors duration-300 ${darkMode ? 'bg-slate-950 text-slate-100' : 'bg-[#FDFCF8] text-stone-900'}`}>
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-6 py-6">
        <a href="/" className="inline-flex items-center gap-2 text-sm font-semibold text-stone-600 transition-colors hover:text-stone-950 dark:text-slate-300 dark:hover:text-white">
          <ArrowLeft size={17} aria-hidden="true" />
          Back to HiCapy
        </a>
        <button
          type="button"
          onClick={() => setDarkMode(!darkMode)}
          aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          className="rounded-full p-2 text-stone-600 transition-colors hover:bg-stone-100 dark:text-slate-300 dark:hover:bg-slate-800"
        >
          {darkMode ? <Sun size={18} /> : <Moon size={18} />}
        </button>
      </nav>

      <section className="mx-auto max-w-6xl px-6 pb-16 pt-12 sm:pt-20">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-emerald-700 dark:text-emerald-400">HiCapy</p>
        <h1 className="mt-4 font-serif text-4xl font-medium leading-tight sm:text-6xl">Meet the founders.</h1>
        <p className="mt-5 max-w-xl text-base leading-7 text-stone-600 dark:text-slate-400">
          The people building HiCapy.
        </p>

        <div className="mt-14 grid gap-12 md:grid-cols-2 md:gap-16">
          {founders.map((founder) => (
            <article key={founder.name} className="border-t border-stone-200 pt-8 dark:border-slate-800">
              <img
                src={founder.image}
                alt={founder.name}
                className="h-44 w-44 rounded-full border-4 border-white object-cover shadow-sm dark:border-slate-800 sm:h-52 sm:w-52"
              />
              <h2 className="mt-7 text-2xl font-semibold">{founder.name}</h2>
              <p className="mt-1 text-sm font-medium text-stone-500 dark:text-slate-400">Founder · {founder.institution}</p>

              {founder.email && (
                <a
                  href={`mailto:${founder.email}`}
                  className="mt-6 flex w-fit items-center gap-2 text-sm font-medium text-stone-700 transition-colors hover:text-emerald-700 dark:text-slate-300 dark:hover:text-emerald-400"
                >
                  <Mail size={16} aria-hidden="true" />
                  {founder.email}
                </a>
              )}
              {founder.website && (
                <a
                  href={founder.website}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-3 flex w-fit items-center gap-2 text-sm font-medium text-stone-700 transition-colors hover:text-emerald-700 dark:text-slate-300 dark:hover:text-emerald-400"
                >
                  <ExternalLink size={16} aria-hidden="true" />
                  snehalpal.vercel.app
                </a>
              )}
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
